import { isReviewOrganizations, isReviewAffiliations, isReviewAffiliation, isReviewHistory, } from '@urbanik/api-contracts';
export class EntityReviewError extends Error {
    status;
    constructor(status) {
        super(status === 403
            ? 'Acceso denegado a esta entidad.'
            : status === 409
                ? 'La afiliación cambió. Actualiza antes de confirmar.'
                : 'No se pudo completar la operación de revisión.');
        this.status = status;
    }
}
async function request(base, path, method = 'GET', body, signal) {
    let response;
    try {
        response = await fetch(base.replace(/\/$/, '') + '/identity/multi-review' + path, {
            method,
            credentials: 'include',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'X-Urbanik-Review': '1',
            },
            ...(body ? { body: JSON.stringify(body) } : {}),
            signal: signal ?? null,
        });
    }
    catch {
        throw new EntityReviewError(503);
    }
    if (!response.ok)
        throw new EntityReviewError(response.status);
    return response.json().catch(() => {
        throw new EntityReviewError(502);
    });
}
export async function reviewLogin(base, email, password) {
    await request(base, '/login', 'POST', { email, password });
}
export async function reviewLogout(base) {
    await request(base, '/logout', 'POST', {});
}
export async function reviewOrganizations(base, signal) {
    const data = await request(base, '/organizations', 'GET', undefined, signal);
    if (!isReviewOrganizations(data))
        throw new EntityReviewError(502);
    return data;
}
export async function reviewAffiliations(base, organizationId, signal) {
    const data = await request(base, '/organizations/' + encodeURIComponent(organizationId) + '/affiliations', 'GET', undefined, signal);
    if (!isReviewAffiliations(data) || data.organizationId !== organizationId)
        throw new EntityReviewError(502);
    return data;
}
export async function reviewChangeAffiliation(base, row, reason, operationId) {
    const data = await request(base, `/organizations/${encodeURIComponent(row.organizationId)}/affiliations/${encodeURIComponent(row.id)}/status`, 'POST', {
        status: row.status === 'active' ? 'inactive' : 'active',
        reason,
        expectedVersion: row.version,
        operationId,
    });
    if (!isReviewAffiliation(data) ||
        data.organizationId !== row.organizationId ||
        data.id !== row.id)
        throw new EntityReviewError(502);
    return data;
}
export async function reviewHistory(base, row, signal) {
    const data = await request(base, `/organizations/${encodeURIComponent(row.organizationId)}/affiliations/${encodeURIComponent(row.id)}/history`, 'GET', undefined, signal);
    if (!isReviewHistory(data) ||
        data.some((r) => r.after.organizationId !== row.organizationId || r.after.id !== row.id))
        throw new EntityReviewError(502);
    return data;
}
